import React from "react";
import axios from "axios";
import { connect } from "react-redux";
import { Button } from 'react-bootstrap';
import xss from "xss";

import "./whiteLabelForm.css";
import { connectForm, Form, OnChange } from "../utils/components/form";
import { BeendenButton } from '../utils/components';
import { DeleteIcon } from "../utils/components/icons";
import { console, getImageMimeTypeOfBlob } from "../utils/functions";
import ToggleMenu from "./toggleMenu";
import FieldArraysForm from "./whiteLabelFieldArraysForm";
import { mandantActions } from "../actions";
import FileList from "./fileList";
import FileItem from "./fileItem.js";
import { InputFieldRow, DropDownRow } from "./components";
import { NEW_MANDANT_DATA, FETCH_MANDANT_LOGO } from '../actions/types/mandant-types';
import RESPONSE_HEADER from "../utils/enums/RESPONSE_HEADER.js";

import DeleteConfirmPopup from "../popups/DeleteMandantConfirmPopup.js";

class WhiteLabelForm extends React.Component {
  constructor(props) {
    super(props);
    this.onSubmitForm = this.onSubmitForm.bind(this);
    this.onChangeGpNummer = this.onChangeGpNummer.bind(this);
    this.onLoadMandant = this.onLoadMandant.bind(this);
    this.onDeleteMandant = this.onDeleteMandant.bind(this);
    this.loadMandant = this.loadMandant.bind(this);
    this.saveLogoImage = this.saveLogoImage.bind(this);
    this.deleteContactImage = this.deleteContactImage.bind(this);
    this.deleteLogoImage = this.deleteLogoImage.bind(this);
    this.validateGpNummer = this.validateGpNummer.bind(this);
    this.onExportSchwellenwerte = this.onExportSchwellenwerte.bind(this);
  }
  labels = {
    issuerUrl: {
      parent: "Mandant",
      label: "Verimi Issuer URL"
    },
    headerLink: {
      parent: "Kopfzeile",
      label: "Kopfzeile-Link"
    },
    mail: {
      parent: "Kontakt",
      label: "Mail Link"
    },
    rueckruf: {
      parent: "Kontakt",
      label: "Rückruf URL"
    },
    terminLink: {
      parent: "Kontakt",
      label: "Termin-Link URL"
    },
    chat: {
      parent: "Kontakt",
      label: "Chat URL"
    },
    bildschirmteilen: {
      parent: "Kontakt",
      label: "Bildschirmteilen URL"
    },
    agb: {
      parent: "Postkörbe & Verlinkungen",
      label: "AGB"
    },
    sammelPostkorb: {
      parent: "Postkörbe & Verlinkungen",
      label: "Sammelpostkorb"
    },
    minOrderValueFiliale: {
      parent: "Erweiterte Einstellungen",
      label: "Minimaler Bestellwert Filiale"
    },
  };
  state = {
    selectedFile: null,
    username: "",
    avatar: "",
    isUploading: false,
    progress: 0,
    avatarURL: "",
    lieferadresseKz: (
      this.props.mandantStorage && this.props.mandantStorage.sonstigeEinstellungen
        ? this.props.mandantStorage.sonstigeEinstellungen.lieferadresseKz
        : null
    ),
    searchLieferadresseAktiv: (
      this.props.mandantStorage && this.props.mandantStorage.sonstigeEinstellungen
        ? this.props.mandantStorage.sonstigeEinstellungen.searchLieferadresseAktiv
        : null
    ),
    ablieferadresseAnkauf: (
      this.props.mandantStorage && this.props.mandantStorage.sonstigeEinstellungen
        ? this.props.mandantStorage.sonstigeEinstellungen.ablieferadresseAnkauf
        : null
    ),
    searchAblieferadresseAktiv: (
      this.props.mandantStorage && this.props.mandantStorage.sonstigeEinstellungen
        ? this.props.mandantStorage.sonstigeEinstellungen.searchAblieferadresseAktiv
        : null
    ),
    abwAdresseBsErlaubt: (
      this.props.mandantStorage && this.props.mandantStorage.sonstigeEinstellungen
        ? this.props.mandantStorage.sonstigeEinstellungen.abwAdresseBsErlaubt
        : null
    ),
    yesVerifiedAdresseKz: (
      this.props.mandantStorage && this.props.mandantStorage.sonstigeEinstellungen
        ? this.props.mandantStorage.sonstigeEinstellungen.yesVerifiedAdresseKz
        : null
    ),
    filesForVVI: [],
    fileLogoImage: null,
    fileContactImage: null,
    gpNummer: this.props.mandantStorage.gpNummer,
    loadError: null,
    loadMessage: "",
    newMandant: false,
    uploadError: null,
    deleteContactError: null,
    deleteLogoError: null,
    uploadContactError: null,
    uploadLogoError: null,
    fileLogoImageData: null,
    fileContactImageData: null,
    updateError: null,
    exportError: null, 
    showDeleteConfirm: false,
    deleteMandantEvent: null,
  };

  componentDidUpdate(prevProps) {
    const prevGpNummer = prevProps.mandantStorage && prevProps.mandantStorage.gpNummer;
    const nextGpNummer = this.props.mandantStorage && this.props.mandantStorage.gpNummer;

    if (prevGpNummer !== nextGpNummer && nextGpNummer !== this.state.gpNummer) {
      this.setState({ gpNummer: nextGpNummer || null });
    }
  }

  onExportSchwellenwerte = async () => {

    if (!this.props.configStorage.isBLBAdmin()) return;

    this.setState({ exportError: null });
    try {

      const url = `${this.props.configStorage.getRestRoot()}/edelmetall/konditionenstufenAll`;
      console.log('Export Schwellenwerte URL:', url);

      const response = await axios.get(url, {
        responseType: 'blob'
      });

      console.log("Export Schwellenwerte Response:", response);

      // Trigger file download
      if (response.data) {
        const timestamp = new Date().toISOString().replace(/:/g, '-').substring(0, 19);
        const filename = `Schwellenwerte_${timestamp}.xlsx`;
        const { download } = require('../utils/functions');
        download(response.data, filename);
        //this.setState({ loadMessage: "Schwellenwerte erfolgreich exportiert." });
      }
    } catch (error) {
      this.setState({ exportError: new Error("Fehler beim Export der Schwellenwerte: " + error.message) });
      console.log("Error exporting Schwellenwerte:", error);
    }
  };

  loadMandant = async (gpNummer) => {
    if (typeof gpNummer !== "string") {
      gpNummer = this.state.gpNummer;
    }
    this.setState({ loadError: null });
    const mandantRequestData = this.props.configStorage.getRequestData("mandant");
    const logoRequestData = this.props.configStorage.getRequestData("loadLogoImage");
    if (gpNummer && this.props.configStorage.isBLBAdmin()) {
      mandantRequestData.url += gpNummer;
      logoRequestData.url += "&gpNummer=" + gpNummer;
    }
    this.setState({
      uploadLogoError: null,
      deleteLogoError: null,
      uploadContactError: null,
      deleteContactError: null,
      updateError: null,
      loadMessage: ""
    });
    await this.props.dispatch(mandantActions.fetchMandantLogo(logoRequestData));
    return this.props.dispatch(mandantActions.fetchMandantData(mandantRequestData))
      .then((res) => {
        if (isNaN(this.props.mandantStorage.id) || (res && res.type === NEW_MANDANT_DATA)) {
          this.setState({
            loadError: false,
            loadMessage: "Es sind keine Daten zum Mandant " + gpNummer + " vorhanden.",
            newMandant: true
          });
        } else {
          this.setState({
            loadError: false,
            loadMessage: "Die Daten zum Mandant " + gpNummer + " wurden geladen."
          });
        }
      })
      .catch((err) => {
        this.setState({ loadError: new Error("Der Mandant " + gpNummer + " konnte nicht geladen werden") });
        console.log("m1", err);
        throw err;
      });
  };

  createEmptyFile() {
    const file = { filename: "", fileOrder: "", fileId: "", newItem: true };
    return file;
  }

  onChangeGpNummer = async (newValue, oldValue) => {
    const gpNummer = Number(newValue);
    if (Number(newValue) > 0 && String(newValue).trim().match(/^\d*$/)) {
      this.setState({ gpNummer: gpNummer });
    } else {
      this.setState({ gpNummer: null });
    }
  };

  onLoadMandant = async () => {
    this.setState({
      loadError: false,
      deleteLogoError: null,
      deleteContactError: null,
      fileContactImageData: null,
      fileContactImage: null,
      fileLogoImageData: null,
      fileLogoImage: null,
      uploadContactError: null,
      uploadLogoError: null,
      updateError: null,
    });
    try {
      await this.loadMandant(this.state.gpNummer);
    } catch (e) {
      console.log(e);
      return;
    }
  };

  performDeleteMandant = async (e) => {
    if (!this.props.configStorage.isBLBAdmin() || !this.props.mandantStorage.gpNummer) return;

    const gpNummer = this.props.mandantStorage.gpNummer;
    this.setState({
      loadError: null,
      updateError: null,
      uploadContactError: null,
      uploadLogoError: null,
      loadMessage: "",
      newMandant: false,
      gpNummer: null
    });
    const mandantRequestData = this.props.configStorage.getRequestData("mandant");
    await this.props.dispatch(mandantActions.deleteMandantData(mandantRequestData.url + gpNummer))
      .then(async () => {
        return this.loadMandant("");
      })
      .then(() => {
        this.setState({ loadMessage: "Der Mandant " + gpNummer + " wurde gelöscht. " + this.state.loadMessage });
      })
      .catch((err) => {
        this.setState({ loadError: new Error("Der Mandant " + gpNummer + " konnte nicht gelöscht werden") });
        console.log("m3", err);
      });

  };

  onDeleteMandant = (e) => {
    this.setState({ showDeleteConfirm: true, deleteMandantEvent: e });
  };

  handleConfirmDelete = () => {
    this.setState({ showDeleteConfirm: false }, () => {
      this.performDeleteMandant(this.state.deleteMandantEvent);
    });
  };

  handleCancelDelete = () => {
    this.setState({ showDeleteConfirm: false });
  };

  submitImage = async (config, imageUrl, parameter, imageType, file, filename) => {
    //neue axios instanz erzeugt, damit interceptor hier nicht greift
    let axiosData = axios.create(config);
    let imageRequestData;
    if (file !== null) {
      imageRequestData = this.props.configStorage.getRequestData(imageType, "post", file);
    } else {
      const image = await fetch(imageUrl)
        .then(response => response.blob())
        .catch(e => {
          console.log(e);
        });
      if (image) {
        const mimeType = await getImageMimeTypeOfBlob(image);
        if (String(mimeType).match(/^image/)) {
          const ext = String(mimeType).match(/^image\/(svg|jpeg|png|gif)?.*/)[1] || "";
          file = new File([image], filename + "." + ext, { type: mimeType });
          imageRequestData = this.props.configStorage.getRequestData(imageType, "post", file);
        }
      }
    }
    if (imageRequestData) {
      return axiosData[imageRequestData.request.type](
        imageRequestData.url + "&" + parameter.toString(),
        imageRequestData.dataToSend,
        imageRequestData.request.config
      );
    } else {
      return Promise.resolve(true);
    }
  };

  onSubmitForm = async formValues => {
    this.setState({
      uploadError: null,
      loadError: null,
      deleteContactError: null,
      deleteLogoError: null,
      uploadContactError: null,
      uploadLogoError: null
    });
    let parameter = new URLSearchParams();
    const mandantRequestData = this.props.configStorage.getRequestData("mandant");
    if (this.state.gpNummer && this.props.configStorage.isBLBAdmin()) {
      parameter.append("gpNummer", this.state.gpNummer);
      mandantRequestData.url += this.state.gpNummer;
    }
    const header = mandantRequestData.json.header;
    // set empty values
    if (typeof this.props.initialValues === "object") {
      Object.keys(this.props.initialValues).forEach(key => {
        if (!formValues[key]) formValues[key] = "";
      });
    }
    let config = {
      headers: {
        request: JSON.stringify(header)
      }
    };

    await this.submitImage(
      config,
      this.props.configStorage.getLogoImageUrl(parameter.toString()),
      parameter,
      "logoImage",
      this.state.fileLogoImage,
      "logo"
    )
      .then(() => {
        this.props.dispatch({ type: FETCH_MANDANT_LOGO, logo: this.state.fileLogoImageData });
        this.setState({ uploadLogoError: false, fileLogoImage: null });
      })
      .catch(error => {
        this.setState({
          uploadLogoError: error,
          updateError: new Error("Fehler beim Speichern der Bilder: " + error)
        });
      });
    await this.submitImage(
      config,
      this.props.configStorage.getContactImageUrl(parameter.toString()),
      parameter,
      "contactImage",
      this.state.fileContactImage,
      "contact"
    )
      .then(() => {
        this.setState({ uploadContactError: false, fileContactImage: null });
      })
      .catch(error => {
        this.setState({
          uploadContactError: error,
          updateError: new Error("Fehler beim Speichern der Bilder: " + error)
        });
      });
    if (!formValues.theme) {
      formValues.theme = this.props.mandantStorage.theme;
    }
    //neue axios instanz erzeugt, damit interceptor hier nicht greift
    let axiosData = axios.create(config);
    axiosData.post(mandantRequestData.url, {
      header,
      mandant: formValues,
    }).then(mandantRes => {
      if (mandantRes && mandantRes.data && mandantRes.data.header && mandantRes.data.header.status === RESPONSE_HEADER.STATUS.SUCCESSFUL) {
        this.setState({
          updateError: false,
          error: null
        });
        this.props.dispatch(mandantActions.fetchMandantData(mandantRequestData));
      } else {
        const errorMsg = mandantRes && mandantRes.data && mandantRes.data.header ? mandantRes.data.header.errorMsg : "Mandant update ist fehlgeschlagen";
        this.setState({ updateError: new Error(xss(errorMsg)) });
      }
    }).catch(error => {
      this.setState({ updateError: error });
    });
  };

  saveLogoImage = e => {
    if (!e || !e.target || !e.target.files || !e.target.files.length) return;
    const file = e.target.files[0];
    //retrieve fileLogo field from state
    const fileLogoImage = file;

    // save dataURL for direct preview
    this.setDataUrlFromImage(fileLogoImage, "fileLogoImageData");
    // save multipart file in state
    this.setState({ fileLogoImage, deleteLogoError: null });
    // Chrome/Edge cleanup input value
    e.target.value = "";
  };

  setDataUrlFromImage(file, stateVar) {
    const state = {
      uploadLogoError: null,
      deleteLogoError: null,
      uploadContactError: null,
      deleteContactError: null,
      updateError: null,
      loadMessage: ""
    };
    state[stateVar] = false;
    try {
      const reader = new FileReader();
      reader.onloadend = () => {
        console.log(reader.result);
        state[stateVar] = reader.result;
        this.setState(state);
      };
      reader.onerror = (e) => {
        console.log(e, reader);
        this.setState(state);
      };
      reader.readAsDataURL(file);
    } catch (e) {
      console.log("no file reader");
      this.setState(state);
    }
  }

  deleteContactImage(e) {
    e.preventDefault();
    this.setState({ deleteContactError: null, uploadContactError: null });
    this.deleteImage("contactImage").then(() => {
      this.setState({ deleteContactError: false, fileContactImageData: null, fileContactImage: null });
    }).catch(error => {
      console.log("deleteContactImage Error", error);
      this.setState({ deleteContactError: new Error("Fehler beim Löschen des Bildes") });
    });
  };

  deleteLogoImage(e) {
    e.preventDefault();
    this.setState({ deleteLogoError: null, uploadLogoError: null });
    this.deleteImage("logoImage").then(() => {
      this.setState({ deleteLogoError: false, fileLogoImageData: null, fileLogoImage: null });
    }).catch(error => {
      console.log("deleteLogoImage Error", error);
      this.setState({ deleteLogoError: new Error("Fehler beim Löschen des Logos") });
    });
  }

  deleteImage(type) {
    const imageRequestData = this.props.configStorage.getRequestData(type, "delete");
    let parameter = new URLSearchParams();
    if (this.state.gpNummer && this.props.configStorage.isBLBAdmin()) {
      parameter.append("gpNummer", this.state.gpNummer);
    }
    return axios[imageRequestData.request.type](
      imageRequestData.url + "&" + parameter.toString(),
    );
  };

  validateGpNummer(gpNummer, _, meta) {
    console.log("gp nummer", gpNummer, meta);
    if (!meta.modified) return;
    if (gpNummer === undefined) return "Geben sie eine GP Nummer an";
    if (isNaN(gpNummer)) return "Geben Sie eine Nummer ein";
    if (Number(gpNummer) <= 0 || !String(gpNummer).trim().match(/^\d*$/)) return "Geben sie eine gültige GP Nummer an";
  }

  //after selecting image - image is stored in state
  saveContactImage = e => {
    if (!e || !e.target || !e.target.files || !e.target.files.length) return;
    const fileContactImage = e.target.files[0];
    this.setDataUrlFromImage(fileContactImage, "fileContactImageData");
    this.setState({ fileContactImage, deleteContactError: null });
    // Chrome/Edge cleanup input value
    e.target.value = "";
  };

  renderErrors(props) {
    return (<>
      {this.state.updateError || this.state.uploadLogoError || this.state.uploadContactError
        ? <div className="alert alert-danger align-items-start">
          <p>Beim Speichern ist ein Fehler aufgetreten:</p>
          {this.state.updateError && this.state.updateError.message
            ? <p className="mb-0">{this.state.updateError.message}</p>
            : null
          }
          {this.state.uploadLogoError && this.state.uploadLogoError.message
            ? <p className="mb-0">Kopfzeile Logo Fehler: {this.state.uploadLogoError.message}</p>
            : null
          }
          {this.state.uploadContactError && this.state.uploadContactError.message
            ? <p className="mb-0">Kontaktbild Fehler: {this.state.uploadContactError.message}</p>
            : null
          }
        </div>
        : null
      }
      {this.state.uploadLogoError === false || this.state.uploadContactError === false || this.state.updateError === false
        ? <div className="alert alert-info align-items-start">
          {this.state.uploadLogoError === false
            ? <p className="mb-0">Kopfzeile Logo erfolgreich gespeichert</p>
            : null
          }
          {this.state.uploadContactError === false
            ? <p className="mb-0">Kontaktbild erfolgreich gespeichert</p>
            : null
          }
          {this.state.updateError === false
            ? <p className="mb-0">Änderungen in den Textfeldern erfolgreich gespeichert</p>
            : null
          }
        </div>
        : null
      }
      {props.errors && props.invalid
        ? <div className="alert alert-danger align-items-start">
          {Object.keys(props.errors).map((key) => {
            if (typeof props.errors[key] === "string") {
              return <p
                key={"error" + key}
                className="mb-0"
              >
                {this.labels[key] ?
                  this.labels[key].parent + " | " + this.labels[key].label
                  : key
                }
                : {props.errors[key]}
              </p>;
            } else if (key === "mandantFooterList") {
              return (props.errors[key] || []).map((col, colIndex) => {
                return ((col && col.rows) || []).map((row, rowIndex) => {
                  if (row && row.rowurl) {
                    return <p
                      key={`error${colIndex}_${rowIndex}`}
                      className="mb-0"
                    >
                      Fußzeile Spalte {colIndex + 1} Zeile {rowIndex + 1}: {String(row.rowurl)}
                    </p>;
                  }
                  return null;
                });
              });
            } else {
              return null;
            }
          })}
        </div>
        : null
      }
      {this.props.configStorage.isBLBAdmin() && !this.state.gpNummer
        ? <div className="alert alert-danger">
          Als Administrator müssen Sie eine GP-Nummer für den Mandanten vergeben
        </div>
        : null
      }
    </>);
  }

  render() {
    const isAdmin = this.props.rightStorage && this.props.rightStorage.isAdmin && this.props.rightStorage.isAdmin();
    const isReadOnlyForRole = !isAdmin;
    let parameter = new URLSearchParams();
    if (this.state.gpNummer && this.props.configStorage.isBLBAdmin()) {
      parameter.append("gpNummer", this.state.gpNummer);
    }
    const logoImageUrl = this.props.configStorage.getLogoImageUrl(parameter.toString());
    const contactImageUrl = this.props.configStorage.getContactImageUrl(parameter.toString());

    return (
      <Form onSubmit={this.onSubmitForm} {...this.props}>
        {props => (
          <div>
            <h2 className="text-secondary">White-Label Konfiguration</h2>
            <div className="row">
              <div className="col-lg-12">
                <div className="mb-one">
                  {this.state.isUploading && (
                    <p>Laden: {this.state.progress}%</p>
                  )}
                </div>
                <form
                  onSubmit={props.handleSubmit}
                  className="form-group"
                >
                  {this.props.configStorage.isBLBAdmin()
                    ? <ToggleMenu name={"Mandant"}>
                      <table className="table">
                        <tbody>
                          <tr class="bg-white">
                            <td></td>
                            <td>
                              <Button
                                variant="info"
                                onClick={this.onExportSchwellenwerte}
                              >
                                Export Schwellenwerte
                              </Button>
                            </td>
                          </tr>
                          {this.state.exportError
                            ? <div className="alert alert-danger alert-dismissible d-flex align-items-center fade show">
                              Export Fehler
                              {this.state.exportError && this.state.exportError.message
                                ? <span>: {this.state.exportError.message}</span>
                                : null
                              }
                            </div>
                            : null
                          }
                          <InputFieldRow
                            name="gpNummer"
                            label="GP Nummer"
                            placeholder={"maximal 7 Stellen"}
                            maxLength="7"
                            validate={this.validateGpNummer}
                          >
                            <div className="pb-1">Hashcode: {this.props.mandantStorage.hash}</div>
                            <Button
                              variant="info"
                              onClick={this.onLoadMandant}
                              disabled={!this.state.gpNummer}
                            >
                              Lade Daten des Mandanten {this.state.gpNummer}
                            </Button>
                            {this.state.loadError
                              ? <div className="alert alert-danger alert-dismissible d-flex align-items-center fade show">
                                Fehler
                                {this.state.loadError && this.state.loadError.message
                                  ? <span>: {this.state.loadError.message}</span>
                                  : null
                                }
                              </div>
                              : null
                            }
                            {this.state.loadMessage
                              ? <div className="alert alert-info alert-dismissible d-flex align-items-center fade show mt-1 mb-0 p-1">
                                {this.state.loadMessage}
                              </div>
                              : null
                            }
                          </InputFieldRow>
                          <OnChange name="gpNummer">{this.onChangeGpNummer}</OnChange>
                          <InputFieldRow
                            name="issuerUrl"
                            label="Verimi Issuer URL"
                            placeholder={"https://Verimi.issuer/url"}
                            tooltip={`Die URL muß mit den Verimi Vorgaben übereinstimmen, ansonsten funktioniert der Login nicht.`}
                            readOnly={isReadOnlyForRole}
                          />
                          <DropDownRow
                            name="theme"
                            label="Farbscheme des Mandanten"
                            disabled={isReadOnlyForRole}
                          >
                            <option value="volksbank">Volksbanken</option>
                            <option value="dkb">DKB</option>
                            <option value="sparkasse">Sparkassen</option>
                            <option value="deutschebank">Deutsche Bank</option>
                            <option value="postbank">Postbank</option>
                          </DropDownRow>
                          <DropDownRow
                            name="emKonditionenKz"
                            label="Konditionen änderbar"
                            disabled={isReadOnlyForRole}
                          >
                            <option value="N">Nein</option>
                            <option value="J">Ja</option>
                          </DropDownRow>
                          <tr class="bg-white">
                            <td></td>
                            <td>
                              <Button
                                className=""
                                variant="danger"
                                onClick={this.onDeleteMandant}
                                disabled={
                                  isReadOnlyForRole ||
                                  isNaN(this.props.mandantStorage.id) ||
                                  this.state.loadError ||
                                  this.state.gpNummer !== this.props.mandantStorage.gpNummer
                                }
                              >
                              Lösche den Mandanten {this.props.mandantStorage.gpNummer}
                              </Button>
                              {/* Confirmation Dialog */}
                              <DeleteConfirmPopup
                                open={this.state.showDeleteConfirm}
                                message="Möchten Sie den Mandanten wirklich löschen?"
                                onConfirm={this.handleConfirmDelete}
                                onCancel={this.handleCancelDelete}
                              />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </ToggleMenu>
                    : null
                  }
                  <ToggleMenu name={"Kopfzeile"}>
                    <table className="table table-hover" >
                      <tbody>
                        <InputFieldRow
                          name="headerLogo"
                          label="Kopfzeile Logo"
                          buttonLabel="Logo auswählen"
                          input={{
                            type: "file",
                            accept: ".svg",
                            onChange: this.saveLogoImage,
                            disabled: isReadOnlyForRole
                          }}
                          imageData={this.state.fileLogoImageData || logoImageUrl}
                          imageClass="logo"
                        >
                          <button type="button"
                            onClick={this.deleteLogoImage}
                            className="btn btn-danger col-1 ms-one"
                            disabled={isReadOnlyForRole}
                          >
                            <DeleteIcon />
                          </button>
                          {this.state.deleteLogoError ?
                            <div className="alert alert-danger p-1">{this.state.deleteLogoError.message}</div>
                            : null
                          }
                          {this.state.deleteLogoError === false
                            ? <div className="alert alert-info p-1">Das Logo Bild wurde gelöscht</div>
                            : null
                          }
                          {this.state.uploadLogoError === false
                            ? <div className="alert alert-info p-1">Das Logo Bild wurde gespeichert</div>
                            : null
                          }
                        </InputFieldRow>
                        <InputFieldRow
                          name="headeralt1"
                          label="Alternativtext"
                          placeholder={"Alternativtext für das Logo"}
                          readOnly={isReadOnlyForRole}
                        />
                        <InputFieldRow
                          name="headerLink"
                          label={this.labels["headerLink"].label}
                          placeholder={"Kopfzeile-Link URL"}
                          input={{ required: true }}
                          readOnly={isReadOnlyForRole}
                        />
                      </tbody>
                    </table>
                  </ToggleMenu>
                  <ToggleMenu name={"Kontakt"}>
                    <p className="fs-6">
                      Möchten Sie die Kontaktmöglichkeiten erweitern oder einschränken, so fügen Sie unter der jeweiligen Rubrik
                      jeweils einen Text hinzu oder löschen Sie den Text, damit die Option verschwindet.
                    </p>
                    <table className="table">
                      <tbody>
                        <InputFieldRow
                          name="avatar"
                          label="Avatar"
                          buttonLabel="Bitte wählen Sie ein Kontaktbild aus"
                          input={{
                            type: "file",
                            accept: "image/*",
                            onChange: this.saveContactImage,
                            disabled: isReadOnlyForRole
                          }}
                          imageData={this.state.fileContactImageData || contactImageUrl}
                        >
                          <button type="button"
                            onClick={this.deleteContactImage}
                            className="btn btn-danger col-1 ms-one"
                            disabled={isReadOnlyForRole}
                          >
                            <DeleteIcon />
                          </button>
                          {this.state.deleteContactError ?
                            <div className="alert alert-danger p-1">{this.state.deleteContactError.message}</div>
                            : null
                          }
                          {this.state.deleteContactError === false
                            ? <div className="alert alert-info p-1">Das Kontaktbild wurde gelöscht</div>
                            : null
                          }
                          {this.state.uploadContactError === false
                            ? <div className="alert alert-info p-1">Das Kontaktbild wurde gespeichert</div>
                            : null
                          }
                        </InputFieldRow>
                        <InputFieldRow
                          name="telefon"
                          label="Telefon"
                          placeholder={"Telefonnummer"}
                          readOnly={isReadOnlyForRole}
                        />
                        <InputFieldRow
                          name="mailTitle"
                          label="Mail Text"
                          placeholder={"Mail Text"}
                          readOnly={isReadOnlyForRole}
                        />
                        <InputFieldRow
                          name="mail"
                          label={this.labels["mail"].label}
                          placeholder={"Mail Link URL"}
                          readOnly={isReadOnlyForRole}
                        />
                        <InputFieldRow
                          name="rueckrufTitle"
                          label="Rückruf Text"
                          placeholder={"Rückruf Text"}
                          readOnly={isReadOnlyForRole}
                        />
                        <InputFieldRow
                          name="rueckruf"
                          label={this.labels["rueckruf"].label}
                          placeholder={"Rückruf URL"}
                          readOnly={isReadOnlyForRole}
                        />
                        <InputFieldRow
                          name="terminLinkTitle"
                          label="Termin-Link Text"
                          placeholder={"Termin-Link Text"}
                          readOnly={isReadOnlyForRole}
                        />
                        <InputFieldRow
                          name="terminLink"
                          label={this.labels["terminLink"].label}
                          placeholder={"Termin-Link URL"}
                          readOnly={isReadOnlyForRole}
                        />
                        <InputFieldRow
                          name="chatTitle"
                          label="Chat-Title Text"
                          placeholder={"Chat Text"}
                          readOnly={isReadOnlyForRole}
                        />
                        <InputFieldRow
                          name="chat"
                          label={this.labels["chat"].label}
                          placeholder={"Chat URL"}
                          readOnly={isReadOnlyForRole}
                        />
                        <InputFieldRow
                          name="bildschirmteilenTitle"
                          label="Bildschirmteilen Text"
                          placeholder={"Bildschirmteilen Text"}
                          readOnly={isReadOnlyForRole}
                        />
                        <InputFieldRow
                          name="bildschirmteilen"
                          label={this.labels["bildschirmteilen"].label}
                          placeholder={"Bildschirmteilen URL"}
                          readOnly={isReadOnlyForRole}
                        />
                      </tbody>
                    </table>
                  </ToggleMenu>
                  <ToggleMenu name={"VVI & Dateianhänge"}>
                    <div>
                      {this.state.uploadError
                        ? <div className="alert alert-danger alert-dismissible d-flex align-items-center fade show">
                          Beim Hochladen ist ein Fehler aufgetreten
                          {this.state.error && this.state.error.message
                            ? <span>: {this.state.error.message}</span>
                            : null
                          }
                        </div>
                        : null
                      }
                      {this.state.newMandant
                        ? <div className="alert alert-warning alert-dismissible d-flex align-items-center fade show">
                          Sie können erst Dateien hochladen, wenn der neue Mandant gespeichert wurde.
                        </div>
                        : null
                      }
                      <div className="fs-5 text-gray">Hochgeladene Dateien verwalten</div>
                      <FileList
                        loadMandant={this.loadMandant}
                        gpNummer={this.state.gpNummer}
                        disabled={this.state.newMandant || isReadOnlyForRole}
                      />
                      <div className="fs-5 text-gray">Weitere Datei hochladen</div>
                      <table>
                        <tbody>
                          <FileItem
                            item={this.createEmptyFile()}
                            loadMandant={this.loadMandant}
                            displayDelete={false}
                            buttonLabel="Upload"
                            disabled={this.state.newMandant || isReadOnlyForRole}
                          />
                        </tbody>
                      </table>
                    </div>
                  </ToggleMenu>
                  <ToggleMenu name={"Fußzeile"}>
                    <p className="fs-6">
                      Möchten Sie die Fußzeile erweitern oder einschränken, so fügen Sie unter der jeweiligen Rubrik
                      jeweils einen Text hinzu oder löschen Sie den Text, damit die Option verschwindet.
                    </p>
                    <FieldArraysForm readOnly={isReadOnlyForRole}></FieldArraysForm>
                  </ToggleMenu>
                  <ToggleMenu name={"Erweiterte Einstellungen"}>
                    <table className="table">
                      <tbody>
                        <InputFieldRow
                          name="schwellenwert"
                          label="Euro-Gegenwert-Schwellenwert Kundenshop"
                          placeholder={"Bitte eine ganze Zahl"}
                          input={{ type: "number" }}
                          tooltip="Mit dieser Option haben Sie die Möglichkeit einzugrenzen, bis zu welchem Gegenwert der
                          Edelmetall-Kundenshop Produkte anzeigt. Zum Beispiel alle Produkte bis 14.999 € Gegenwert
                          (Direktversand-Grenze bei Edelmetallen)."
                          readOnly={isReadOnlyForRole}
                        />
                        <InputFieldRow
                          name="minOrderValueFiliale"
                          label="Minimaler Bestellwert Filiale"
                          placeholder={"Bitte eine ganze Zahl bis maximal 25000"}
                          input={{ type: "number", min: 0, max: 25000, step: 1 }}
                          tooltip="Mit dieser Option legen Sie den minimalen Bestellwert für Filialaufträge fest. Der maximal zulässige Wert beträgt 25000."
                          readOnly={isReadOnlyForRole}
                        />
                        <DropDownRow
                          name="yesVerifiedAdresseKz"
                          label="von Verimi verifizierte Adresse"
                          tooltip="Achtung: Die Verifizierung der Kundenadresse ist nur erforderlich, wenn Sie nicht möchten, dass der Kunde
                          seinen Wohnort frei angeben darf. Die Änderung ist für den Webshop-Anbieter gebührenpflichtig."
                          disabled={isReadOnlyForRole}
                        >
                          <option value="N">Nein</option>
                          <option value="J">Ja</option>
                        </DropDownRow>
                        <DropDownRow
                          name="lieferadresseKz"
                          label="zusätzliche Lieferadresse von Kunden erlaubt"
                          tooltip={`Hier können Sie festlegen, ob Ihr Kunde die Lieferadresse frei wählen darf. Falls Sie nicht
                          möchten, dass der Kunde seine Lieferadresse wählen darf, müssen Sie bei der Verifizierung der
                          Kundenandresse "Ja" angeben und bei der Änderung der Lieferadresse "Nein".`}
                          disabled={isReadOnlyForRole}
                        >
                          <option value="N">Nein</option>
                          <option value="J">Ja</option>
                        </DropDownRow>
                        <DropDownRow
                          name="searchLieferadresseAktiv"
                          label="Suche Lieferadresse aktiv"
                          tooltip={`Hier können Sie festlegen, ob die Suchfunktion für Lieferadressen aktiv sein soll.`}
                          disabled={isReadOnlyForRole}
                        >
                          <option value="N">Nein</option>
                          <option value="J">Ja</option>
                        </DropDownRow>
                        <DropDownRow
                          name="ablieferadresseAnkauf"
                          label="Ablieferadresse Ankauf"
                          tooltip={`Hier können Sie festlegen, ob eine Ablieferadresse beim Ankauf erfasst werden kann.`}
                          disabled={isReadOnlyForRole}
                        >
                          <option value="N">Nein</option>
                          <option value="J">Ja</option>
                        </DropDownRow>
                        <DropDownRow
                          name="searchAblieferadresseAktiv"
                          label="Suche Ablieferadresse aktiv"
                          tooltip={`Hier können Sie festlegen, ob die Suchfunktion für Ablieferadressen aktiv sein soll.`}
                          disabled={isReadOnlyForRole}
                        >
                          <option value="N">Nein</option>
                          <option value="J">Ja</option>
                        </DropDownRow>
                        <DropDownRow
                          name="abwAdresseBsErlaubt"
                          label="Abweichende Kundenadresse im Beratershop erlaubt"
                          tooltip={`Hier können Sie festlegen, ob im Beratershop eine abweichende Kundenadresse eingegeben werden kann.`}
                          disabled={isReadOnlyForRole}
                        >
                          <option value="N">Nein</option>
                          <option value="J">Ja</option>
                        </DropDownRow>
                      </tbody>
                    </table>                  </ToggleMenu>
                  <ToggleMenu name={"Postkörbe & Verlinkungen"}                  >
                    <table className="table">
                      <tbody>
                        <InputFieldRow
                          name="agb"
                          label="AGB"
                          placeholder={"Link zur AGB Seite"}
                          readOnly={isReadOnlyForRole}
                        />
                        <InputFieldRow
                          name="sammelPostkorb"
                          label={this.labels["sammelPostkorb"].label}
                          placeholder={"Sammelpostkorb"}
                          input={{ required: true }}
                          readOnly={isReadOnlyForRole}
                        />
                        <InputFieldRow
                          name="vviLink"
                          label="VVI Link"
                          placeholder={"Link für die VVI"}
                          readOnly={isReadOnlyForRole}
                        /> 
                        <InputFieldRow
                          name="absenderMailAdresse"
                          label="Absender Email"
                          placeholder={"Absender Email"}
                          readOnly={isReadOnlyForRole}
                        />
                      </tbody>
                    </table>
                  </ToggleMenu>
                  {this.renderErrors(props)}
                  <div className="d-flex flex-wrap justify-content-between mt-two">
                    <Button
                      variant="primary"
                      type="button"
                      className="col-12 col-md-4 col-lg-2"
                      onClick={props.handleSubmit}
                      disabled={isReadOnlyForRole || (this.props.configStorage.isBLBAdmin() && !this.state.gpNummer) || props.invalid}
                    >
                      Speichern
                      {this.props.configStorage.isBLBAdmin() && this.state.gpNummer
                        ? <span className="ps-1">(GP {this.state.gpNummer})</span>
                        : null
                      }
                    </Button>
                    {this.props.configStorage.isVerseNeo()
                      ? <>
                        <a
                          href={this.props.configStorage.getBackToLandingPageLink()}
                          className="btn btn-info col-12 col-md-3 col-lg-2"
                        >
                          Zurück zur Startseite
                        </a>
                        <BeendenButton className="col-12 col-md-3 col-lg-2" />
                      </>
                      : null
                    }
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}
      </Form >
    );
  }
};

export const validate = formValues => {
  const errors = {};
  const urlRegExp = /^(https:\/\/)([A-Za-z0-9.-]+)(\/[+~%/.\w_-]*)?(\?[+~%/.\w_=&-]*)?(#.*)?/;
  const mailtoRegExp = /^mailto:[\w\-.]+@([\w-]+\.)+[\w-]{2,4}$/;
  const mailRegExp = /^[\w\-.]+@([\w-]+\.)+[\w-]{2,4}$/;
  if (formValues.issuerUrl && !String(formValues.issuerUrl).match(urlRegExp)) {
    errors.issuerUrl = "Geben Sie eine gültige URL an (https://domain.de)";
  }
  if (!formValues.headerLink) {
    errors.headerLink = "Geben Sie ein gültige URL an (https://domain.de)";
  } else if (formValues.headerLink && !String(formValues.headerLink).match(urlRegExp)) {
    errors.headerLink = "Geben Sie eine gültige URL an (https://domain.de)";
  }
  if (formValues.mail && !String(formValues.mail).match(mailtoRegExp) && !String(formValues.mail).match(urlRegExp)) {
    errors.mail = "Geben Sie ein gültiges eMail Format an (mailto:postkorb@domain.de) oder eine gültige URL (https://domain.de)";
  }
  if (formValues.rueckruf && !String(formValues.rueckruf).match(urlRegExp)) {
    errors.rueckruf = "Geben Sie eine gültige URL an (https://domain.de)";
  }
  if (formValues.terminLink && !String(formValues.terminLink).match(urlRegExp)) {
    errors.terminLink = "Geben Sie eine gültige URL an (https://domain.de)";
  }
  if (formValues.chat && !String(formValues.chat).match(urlRegExp)) {
    errors.chat = "Geben Sie eine gültige URL an (https://domain.de)";
  }
  if (formValues.bildschirmteilen && !String(formValues.bildschirmteilen).match(urlRegExp)) {
    errors.bildschirmteilen = "Geben Sie eine gültige URL an (https://domain.de)";
  }
  (formValues.mandantFooterList || []).forEach((footer, fidx) => {
    (footer.rows || []).forEach((row, ridx) => {
      if (row.rowurl && !String(row.rowurl).match(urlRegExp)) {
        if (!errors.mandantFooterList) errors.mandantFooterList = [];
        if (!errors.mandantFooterList[fidx]) errors.mandantFooterList[fidx] = { rows: [] };
        errors.mandantFooterList[fidx].rows[ridx] = { rowurl: "Geben Sie eine gültige URL an (https://domain.de)" };
      }
    });
  });
  if (formValues.agb && !String(formValues.agb).match(urlRegExp)) {
    errors.agb = "Geben Sie eine gültige URL an (https://domain.de)";
  }
  if (!formValues.sammelPostkorb) {
    errors.sammelPostkorb = "Geben Sie ein gültige eMail an";
  } else if (!String(formValues.sammelPostkorb).match(mailRegExp)) {
    errors.sammelPostkorb = "Geben Sie ein gültiges eMail Format an (postkorb@domain.de)";
  }
  if (formValues.absenderMailAdresse && !String(formValues.absenderMailAdresse).match(mailRegExp)) {
    errors.absenderMailAdresse = "Geben Sie ein gültiges eMail Format an (absender@domain.de)";
  }
  if (formValues.vviLink && !String(formValues.vviLink).match(urlRegExp)) {
    errors.vviLink = "Geben Sie eine gültige URL an (https://domain.de)";
  }
  if (formValues.minOrderValueFiliale !== undefined && formValues.minOrderValueFiliale !== null && String(formValues.minOrderValueFiliale) !== "") {
    if (!String(formValues.minOrderValueFiliale).match(/^\d+$/)) {
      errors.minOrderValueFiliale = "Geben Sie eine ganze Zahl an";
    } else if (Number(formValues.minOrderValueFiliale) > 25000) {
      errors.minOrderValueFiliale = "Der maximale Wert beträgt 25000";
    }
  }
  return errors;
};

export default connectForm({
  form: "whitelabelForm",
  validate: validate
})(connect((store) => {
  return {
    configStorage: store.configStorage,
    mandantStorage: store.mandantStorage,
    rightStorage: store.rightStorage
  };
})(WhiteLabelForm));
